module.exports = __webpack_public_path__ + "img/a30bbef.jpg";